module.exports = __webpack_public_path__ + "static/media/mbg.afe29858.jpg";